import React from 'react';

import User from '../../../Api/Models/User';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';

function UserDetailsShort({ user }: { user: User }) {
    return (
        <Card title="User details">
            <TableDetailsBody>
                <Row label="ID">{user.id}</Row>
                <Row label="Email">{user.email}</Row>
                <Row label="Phone">{user.phone}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default UserDetailsShort;
